import { memo } from "react";
import { cn } from "@repo/design-system/utils";
import { Button } from "@medusajs/ui";
import { ArrowRight, Loader2 } from "lucide-react";

export interface CheckoutButtonProps {
  /** Callback when checkout button is clicked */
  onClick: () => void;
  /** Whether the button is disabled */
  disabled?: boolean;
  /** Whether checkout is in progress */
  isLoading?: boolean;
  /** Optional className */
  className?: string;
}

/**
 * Checkout button for cart mode.
 * Hidden in checkout mode since user is already in checkout flow.
 */
export const CheckoutButton = memo(function CheckoutButton({
  onClick,
  disabled = false,
  isLoading = false,
  className
}: CheckoutButtonProps) {
  return (
    <div className={cn("px-6 pb-4", className)}>
      <Button
        onClick={onClick}
        disabled={disabled || isLoading}
        className="w-full"
        size="large"
        aria-label="Proceed to checkout"
        aria-disabled={disabled}
      >
        {isLoading ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Processing...
          </>
        ) : (
          <>
            Proceed to checkout
            <ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" />
          </>
        )}
      </Button>
    </div>
  );
});
